import { Department } from '@trustero/trustero-api-web/lib/model/department_pb'
import { PolicyRecord } from '@trustero/trustero-api-web/lib/model/policy_pb'
import { NONE_ID } from 'src/Utils/globalConstants'

export const getDepartmentPolicyMap = (
  departments: Department[],
  policies: PolicyRecord[],
): Record<string, string[]> => {
  const departmentPolicyMap: Record<string, string[]> = {}
  departments.forEach((department) => {
    departmentPolicyMap[department.getName()] = policies
      .filter((policy) => policy.getDepartmentId() === department.getId())
      .map((policy) => policy.getName())
    departmentPolicyMap[department.getShortName()] = policies
      .filter((policy) => policy.getDepartmentId() === department.getId())
      .map((policy) => policy.getName())
  })
  const parentlessPolicies = policies.filter(
    (policy) => !policy.getDepartmentId(),
  )
  departmentPolicyMap[NONE_ID] = [
    ...parentlessPolicies.map((policy) => policy.getName()),
    NONE_ID,
  ]
  return departmentPolicyMap
}
